import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeScreenComponent } from "./welcome/home-screen/home-screen.component";
import { AuthGuard } from "./_helpers/auth.guard";
import { NotAuthGuard } from "./_helpers/not-auth.guard";

const routes: Routes = [
  {
    path: "welcome",
    children: [
      {
        path: "",
        redirectTo: "home",
        pathMatch: "full",
      },
      {
        path: "home",
        component: HomeScreenComponent,
        canActivate: [NotAuthGuard],
      },
      {
        path: "start",
        canActivate: [NotAuthGuard],
        loadChildren: () =>
          import("./welcome/start/start.module").then((m) => m.StartModule),
      },
      {
        path: "menu",
        canActivate: [AuthGuard],
        children: [
          {
            path: "",
            loadChildren: () =>
              import("./welcome/home-menu/home-menu.module").then(
                (m) => m.HomeMenuModule
              ),
          },
          {
            path: "password-update",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/password-update/password-update.module"
                  ).then((m) => m.PasswordUpdateModule),
              },
            ],
          },
          {
            path: "users",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/user-management/user-management.module"
                  ).then((m) => m.UserManagementModule),
              },
            ],
          },
          {
            path: "zones",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/zone-management/zone-management.module"
                  ).then((m) => m.ZoneManagementModule),
              },
            ],
          },
          {
            path: "pays",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/pays-management/pays-management.module"
                  ).then((m) => m.PaysManagementModule),
              },
            ],
          },
          {
            path: "intermediaries",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/pos-management/pos-management.module"
                  ).then((m) => m.PosManagementModule),
              },
            ],
          },
          {
            path: "monitoring",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/historic-management/historic-management.module"
                  ).then((m) => m.HistoricManagementModule),
              },
            ],
          },
          {
            path: "historique-souscription",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-souscription-history/automobile-souscription-history.module"
                  ).then((m) => m.AutomobileSouscriptionHistoryModule),
              },
            ],
          },
          {
            path: "annulation-impression",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/annulation-impression/annulation-impression.module"
                  ).then((m) => m.AnnulationImpressionModule),
              },
            ],
          },
          {
            path: "admin-branches",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-branches/bancassurance-admin-branches.module"
                  ).then((m) => m.BancassuranceAdminBranchesModule),
              },
            ],
          },
          {
            path: "admin-templates",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-templates/bancassurance-admin-templates.module"
                  ).then((m) => m.BancassuranceAdminTemplatesModule),
              },
            ],
          },
          {
            path: "admin-questionnaires",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-questionnaires/bancassurance-admin-questionnaires.module"
                  ).then((m) => m.BancassuranceAdminQuestionnairesModule),
              },
            ],
          },
          {
            path: "admin-banks",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-banks/bancassurance-admin-banks.module"
                  ).then((m) => m.BancassuranceAdminBanksModule),
              },
            ],
          },
          {
            path: "admin-products",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-products/bancassurance-admin-products.module"
                  ).then((m) => m.BancassuranceAdminProductsModule),
              },
            ],
          },
          {
            path: "admin-bancassurance-users",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-user-management/bancassurance-user-management.module"
                  ).then((m) => m.BancassuranceUserManagementModule),
              },
            ],
          },
          {
            path: "bancassurance-menu",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-menu/bancassurance-menu.module"
                  ).then((m) => m.BancassuranceMenuModule),
              },
            ],
          },

        ],
      },
      {
        path: "thankyou",
        loadChildren: () =>
          import("./welcome/exit-screen/exit-screen.module").then(
            (m) => m.ExitScreenModule
          ),
      },
      {
        path: "intro",
        loadChildren: () =>
          import("./welcome/intro-screen/intro-screen.module").then(
            (m) => m.IntroScreenModule
          ),
      },
    ],
  },
  { path: "", redirectTo: "/welcome/home", pathMatch: "full" },
  {
    path: "**",
    redirectTo: "/welcome/home",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
